module.exports = __webpack_public_path__ + "../resources/img/ic_play_disable_light.f6c130fa.svg";